<template>
    <div class="hand layout-page-box" v-loading='loading'>
        <div class="layTitle">
            <div class="title">长期医嘱单</div>
            <div>
                <el-button type="danger" size="small" @click="close">返回留观管理</el-button>
            </div>
        </div>
        <el-form :inline="true" :model="formData" class="formBox">
            <el-form-item label="姓名">
                <el-input @input="testSX" disabled v-model.trim="formData.clientName" style="width:60%;" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="年龄">
                <el-input @input="testSX" disabled v-model.trim="formData.clientAge" style="width:60%;" placeholder="请输入年龄"></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-select @input="testSX" disabled v-model="formData.clientSex" clearable placeholder="请选择性别" style="width:60%;">
                    <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="床号">
                <el-input @input="testSX" disabled v-model.trim="formData.bedNumber" style="width:60%;" placeholder="请输入床号"></el-input>
            </el-form-item>
            <el-form-item label="科别">
                <el-input disabled v-model.trim="formData.departmentName" style="width:60%;"></el-input>
            </el-form-item>
        </el-form>
        <child :formData="formData" :doctorData="doctorData" :nurseData="nurseData"></child>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import child from './child'
import { log } from 'util';
export default {
    components: {
        child
    },
    name: 'orderSheet',
    // props: ['formData'],
    computed: {
        ...mapState(["sexey",]),
        ...mapGetters(['orderDoctorList', 'orderNurseList', 'orderList']),
    },
    data() {
        return {
            passData: {},
            formData: {
                doctorAdviceList: []
            },
            doctorData: [],
            orderDatas: [],
            nurseData: [],
            arr1: [],
            arr2: [],
            loading: false
        }
    },
    // watch: {
    //     $route(to, from) {
    //         this.init()
    //     },
    // },
    // 解决切换页面多次调用路由问题
    activated() {
        this.activatedFlag = true
        if (this.activatedFlag) {
            this.init()
        }
    },
    deactivated() { this.activatedFlag = false; },
    mounted() {
        this.$store.dispatch('getOrderList')
        this.$store.dispatch('getNurseMenuList')
        this.loading = true
        setTimeout(() => {
            // 医生列表渲染
            this.doctorData = this.orderDoctorList
            // 护士列表渲染
            this.nurseData = this.orderNurseList
            // console.log(this.doctorData);
            // console.log(this.nurseData);
            this.loading = false
        }, 500);

    },
    created() {
        this.init()
    },

    methods: {
        testSX() {
            this.$forceUpdate()
        },
        init() {
            console.log(this.$route.params);
            if (this.$route.params) {
                this.passData = this.$route.params
                if (this.passData.code == 1) {
                    this.formData = this.passData
                    this.formData.doctorAdviceList.forEach(item => {
                        // 字符串转数字处理
                        item.startDoctorNo = Number(item.startDoctorNo)
                        item.startNurseNo = Number(item.startNurseNo)
                        item.stopDoctorNo = Number(item.stopDoctorNo)
                        item.stopNurseNo = Number(item.stopNurseNo)
                    });

                } else if (this.passData.code == 0) {
                    this.formData = {
                        doctorAdviceList: []
                    }
                }
                this.formData.bedNumber = this.passData.bedNumber
                this.formData.clientName = this.passData.clientName
                this.formData.clientAge = this.passData.clientAge
                this.formData.clientSex = this.passData.clientSex
                this.formData.hospitalizedTime = this.passData.hospitalizedTime
                this.formData.departmentName = '美容外科'
                this.formData.code = this.passData.code
            }
        },
        close() {
            router.push('/observation/observation')
        },
        sure() {
            console.log(this.formData);
            this.formData.createBy = Lockr.get('skinEmpId');
            this.formData.departmentName = '美容外科'
            // 护士列表
            let arr1 = this.nurseList.concat(this.assistantList)


            console.log(this.formData.doctorAdviceList);
            this.formData.doctorAdviceList.forEach(item => {
                // startDoctorName：医生签名（开始）
                // startDoctorNo：医生签名id（开始）
                // stopDoctorName：医生签名（停止）
                // stopDoctorNo：医生签名id（停止）
                this.doctorList.forEach(ele => {
                    if (item.startDoctorNo == ele.id) {
                        item.startDoctorName = ele.menuName
                    }
                    if (item.stopDoctorNo == ele.id) {
                        item.stopDoctorName = ele.menuName
                    }
                });
                // startNurseName：护士签名（开始）
                // startNurseNo：护士签名id（开始）
                // stopNurseName：护士签名（停止）
                // stopNurseNo：护士签名id（停止）
                arr1.forEach(ele => {
                    if (item.startNurseNo == ele.id) {
                        item.startNurseName = ele.menuName
                    }
                    if (item.stopNurseNo == ele.id) {
                        item.stopNurseName = ele.menuName
                    }
                });
            });
            // 新增
            if (this.formData.code == 0) {
                this.formData.leaveObserveId = this.passData.id;
                api.requestQuiet("/leaveObserve/createDoctorAdvicePermanently", this.formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '长期医嘱添加成功');
                        router.push({ path: '/observation/observation', query: { code: 0 }, })
                        //  router.push({ name: 'observation', params: data })
                        // this.$router.go(0);
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (this.formData.code == 1) {
                this.formData.leaveObserveId = this.passData.leaveObserveId;
                api.requestQuiet("/leaveObserve/updateDoctorAdvicePermanently", this.formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '长期医嘱修改成功');
                        router.push({ path: '/observation/observation', query: { code: 0 } })
                        // router.push('/observation/observation')
                        // this.$router.go(0);
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }
        },
    },

}
</script>

<style scoped>
.title {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 0;
}
.people {
  margin-right: 20px;
}
.sureButton {
  display: flex;
}
.handForm {
  border: 1px solid #eee;
}
.partFooter {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
/* .layout-page-box >>> .el-form-item {
  margin-bottom: 10px !important;
} */
.formBox >>> .el-form-item__content {
  line-height: 32px !important;
}
.layTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


